import React, { Component } from "react";
import firebaseManager from "../../../../model/Firebase/FirebaseManager";
import { Redirect } from "react-router-dom";

class FacebookLogin extends Component {
  constructor() {
    super();
    this.state = {
      redirectToHome: false,
    };
  }

  signInWithPopup = () => {
    firebaseManager.loginUserWithFacebookTechnician(
      this.loginCallbackSuccess,
      this.loginCallbackFail
    );
  };

  loginCallbackSuccess = () => {
    this.setState({
      redirectToHome: true,
    });
  };
  loginCallbackFail(errMessage) {
    alert(errMessage);
  }
  render() {
    return (
      <div className="text-center">
        {this.state.redirectToHome ? (
          <Redirect push to="/homeTechnician" />
        ) : null}
        <button
          className="btn btnFacebook mt-1 mx-auto"
          onClick={this.signInWithPopup}
        >
          Sign in with Facebook
        </button>
      </div>
    );
  }
}

export default FacebookLogin;
